<div class="cart-container" rt="app-header-cart" (click)="open()">
  <div class="circle" [class.active]="numberOfItemsInCart > 0" [class.dark]="darkTheme"></div>
  <div class="number-of-items" [class.active]="numberOfItemsInCart > 0" [class.dark]="darkTheme">{{numberOfItemsInCart}}</div>
  <i class="icon-shopping-cart" [class.dark]="darkTheme"></i>
</div>
